export const getBillingTransactions = () => {
    return (dispatch, getState) => {
      const userID = getState().firebase.auth.uid;
    (async () => {
      
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/getBillingTransactions?userID='+userID);
        
      const resp = await rawResponse.json();
    
      console.log(resp);
      if (resp !== null && resp !== undefined && resp.err === undefined) {
        let transactions = resp.transactions;
        dispatch({ type: 'BILLING_TRANSACTIONS_RETRIEVED', transactions});
        //this.setState({"journalLogs" : content});
      } else {
        let transactions = new Array();
        dispatch({ type: 'BILLING_TRANSACTIONS_RETRIEVED', transactions});
      }
  
    })();
    }
  };

  export const getCardOnFile = () => {
    return (dispatch, getState) => {
      const userID = getState().firebase.auth.uid;
    (async () => {
      
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/getBillingInfo?userID='+userID);
        
      const resp = await rawResponse.json();
    
      console.log(resp);
      if (resp !== null && resp !== undefined && resp.err === undefined) {
        
        dispatch({ type: 'BILLING_INFO_RETRIEVED', cardOnFile: resp.cardOnFile});
        
      } else {
        dispatch({ type: 'BILLING_INFO_RETRIEVED', cardOnFile: {}});
      }
  
    })();
    }
  };

export const addNewPlan = (planName) => {
  return (dispatch, getState) => {
    const userID = getState().firebase.auth.uid;
    (async () => {
      let req = {};
      req.userID=userID;
      req.planName=planName;
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newPlan', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      const planResponse = await rawResponse;
    
      console.log(planResponse);
      
      dispatch({ type: 'PLAN_ADDED', planName});
        //this.setState({"journalLogs" : content});
      

    })();
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/billingActions.js